import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const DiamondIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 17" width="16px" height="17px" fill="none" {...props}>
    <mask
      id="mask0_16561_34538"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="17"
    >
      <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16561_34538)">
      <path
        d="M8.00065 14.5L1.33398 6.5L3.33398 2.5H12.6673L14.6673 6.5L8.00065 14.5ZM6.41732 5.83333H9.58398L8.58398 3.83333H7.41732L6.41732 5.83333ZM7.33398 11.6167V7.16667H3.63398L7.33398 11.6167ZM8.66732 11.6167L12.3673 7.16667H8.66732V11.6167ZM11.0673 5.83333H12.834L11.834 3.83333H10.0673L11.0673 5.83333ZM3.16732 5.83333H4.93398L5.93398 3.83333H4.16732L3.16732 5.83333Z"
        fill="#41AA92"
      />
    </g>
  </Icon>
);

export default DiamondIcon;
